import { useEffect, useState, useMemo } from "react";
import {
  Box,
  Typography,
  IconButton,
  Paper,
  Container,
  Grid,
  CircularProgress,
} from "@mui/material";
import AddBoxOutlinedIcon from "@mui/icons-material/AddBoxOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import LockPersonIcon from "@mui/icons-material/LockPerson";
import SettingsIcon from "@mui/icons-material/Settings";
import { useNavigate } from "react-router-dom";
import logo from "../images/SCY B+Color.png";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import GroupIcon from "@mui/icons-material/Group";
import { useAuth } from "../contexts/AuthContext";
import DashboardIcon from "@mui/icons-material/Dashboard";
import DialpadIcon from '@mui/icons-material/Dialpad';
const buttonsTop = [
  {
    label: "รับซื้อ",
    icon: <AddBoxOutlinedIcon fontSize="large" />,
    route: "/buy",
    roles: ["Admin", "Manager", "Officer", "Warehouse"],
  },
  // {
  //   label: "ขาย",
  //   icon: <AddBoxOutlinedIcon fontSize="large" />,
  //   route: "/sale",
  //   roles: ["Admin", "Manager", "Officer", "Warehouse"],
  // },
  {
    label: "รายงาน",
    icon: <DescriptionOutlinedIcon fontSize="large" />,
    route: "/reports",
    roles: ["Admin", "Manager", "Officer"],
  },
  // {
  //   label: "Dashboard",
  //   icon: <DashboardIcon fontSize="large" />,
  //   route: "/reports",
  //   roles: ["Admin", "Manager", "Officer"],
  // },
  {
    label: "จัดการซัพพลายเออร์",
    icon: <ManageAccountsIcon fontSize="large" />,
    route: "/customers",
    roles: ["Admin", "Manager", "Officer"],
  },
  // {
  //   label: "จัดการซัพพลายเออร์ฝั่งขาย",
  //   icon: <ManageAccountsIcon fontSize="large" />,
  //   route: "/sale-customers",
  //   roles: ["Admin", "Manager", "Officer"],
  // },
  {
    label: "จัดการกลุ่มซัพพลายเออร์",
    icon: <GroupIcon fontSize="large" />,
    route: "/customer_group",
    roles: ["Admin", "Manager", "Officer"],
  },
  // {
  //   label: "จัดการร้านค้า",
  //   icon: <SettingsIcon fontSize="large" />,
  //   // route: "https://shop.saleng.tjl.co.th",
  //   route: "http://localhost:3001/product",
  //   external: true,
  //   roles: ["Admin", "Manager"],
  // },
  // {
  //   label: "จัดการใบเสนอราคา\n(PO)",
  //   icon: <DescriptionOutlinedIcon fontSize="large" />,
  //   route: "/po_management",
  //   roles: ["Admin", "Manager", "Officer"],
  // },
  // {
  //   label: "จัดการใบเสนอราคาขาย\n(SO)",
  //   icon: <DescriptionOutlinedIcon fontSize="large" />,
  //   route: "/so_management",
  //   roles: ["Admin", "Manager", "Officer"],
  // },
  // {
  //   label: "ล็อกราคาสินค้า",
  //   icon: <LockPersonIcon fontSize="large" />,
  //   route: "/lock_pricing",
  //   roles: ["Admin", "Manager", "Officer"],
  // },
  {
    label: "คลังสินค้า",
    icon: <Inventory2OutlinedIcon fontSize="large" />,
    route: "/stock",
    roles: ["Admin", "Manager", "Officer", "Warehouse"],
  },
  // {
  //   label: "จัดการปุ่มซื้อขาย",
  //   icon: <DialpadIcon fontSize="large" />,
  //   route: "/edit_button",
  //   roles: ["Admin", "Manager", "Officer", "Warehouse"],
  // },
];

const HomePage = () => {
  const navigate = useNavigate();
  const auth = useAuth();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (auth !== null) {
      setIsLoading(false);
    }
  }, [auth]);

  const filteredButtons = useMemo(() => {
    if (!auth?.role) return [];
    return buttonsTop.filter(
      (btn) => btn.roles.length === 0 || btn.roles.includes(auth.role)
    );
  }, [auth]);

  if (isLoading) {
    return (
      <Box
        minHeight="100vh"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box
      minHeight="100vh"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      sx={{
        background: "linear-gradient(135deg, #e0f7fa, #ffffff)",
        px: 2,
      }}
    >
      <Container maxWidth="lg">
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          flexWrap="wrap"
          sx={{ mb: 2 }}
        >
          <img
            src={logo}
            alt="logo"
            style={{ width: 300, height: 100, marginRight: 16 }}
          />
        </Box>

        {/* Welcome text */}
        <Typography variant="h6" align="center" sx={{ mb: 4 }}>
          ยินดีต้อนรับ! กรุณาเลือกเมนูด้านล่าง
        </Typography>

        {/* Button grid */}
        <Grid container spacing={2} justifyContent="center">
          {filteredButtons.map((btn, index) => (
            <Grid item xs={6} sm={4} md={2} key={index}>
              <Box
                onClick={() => {
                  if (btn.external) {
                    window.open(btn.route, "_blank");
                  } else {
                    navigate(btn.route);
                  }
                }}
                sx={{ cursor: "pointer", textAlign: "center" }}
              >
                <Paper
                  elevation={4}
                  sx={{
                    p: 3,
                    borderRadius: "50%",
                    backgroundColor: "#ffffff",
                    width: 120,
                    height: 120,
                    mx: "auto",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    transition: "all 0.3s",
                    ":hover": {
                      backgroundColor: "#185519",
                      color: "#fff",
                      transform: "scale(1.05)",
                    },
                  }}
                >
                  <IconButton color="inherit" size="large">
                    {btn.icon}
                  </IconButton>
                </Paper>
                <Typography align="center" sx={{ mt: 2, fontWeight: "bold" }}>
                  {btn.label}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default HomePage;
